import { MissingTranslationHandler, MissingTranslationHandlerParams } from '@ngx-translate/core';

export class MissingTranslationHandlerDIAN implements MissingTranslationHandler {

    handle(params: MissingTranslationHandlerParams) {
      console.log('Traducción no encontrada, verifique los archivos de idiomas en la siguiente ruta del proyecto assets/i18n', params);
      return 'Por favor verifique que el objeto que esta tratando de acceder se encuentre para el idioma que esta intentando ver';
    }

}


// WEBPACK FOOTER //
// D:/350/ng_ingreso_retefuente350/ReteFuente350Ingreso/src/app/configuracion/missing-translation-handler-dian.ts